import React from 'react';
import LocationTemplate from './LocationTemplate';

const ColerainPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Colerain"
      stateName="North Carolina"
      countyName="Bertie"
      zipCodes={["27924"]}
      latitude={36.1962}
      longitude={-76.7730}
      population={208}
      historicalFact="Named after the Coleraine settlement in Ireland; established as an early colonial port."
      nearbyTowns={[
        "Windsor, NC",
        "Aulander, NC",
        "Ahoskie, NC",
        "Plymouth, NC",
        "Powellsville, NC",
        "Rich Square, NC",
        "Kelford, NC",
        "Roper, NC"
      ]}
    />
  );
};

export default ColerainPage;